export default __webpack_public_path__ + "static/media/thumbnail-community.665a1be8.png";